import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Dialog,
} from "@mui/material";
import axios, { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL } from "../consts";
import { Dispositivi } from "../prismaTypes";
import EditIcon from "@mui/icons-material/Edit";
import { useState } from "react";
import { Dispositivo } from "./Dispositivo";
import { queryClient } from "../App";
import { useSnackbar } from "notistack";
import DeleteIcon from "@mui/icons-material/Delete";

export function DispositiviUi(props: { clubId: number; risorseId: number }) {
  const { risorseId, clubId } = props;
  const [open, setOpen] = useState(false);
  const [disp, setDisp] = useState<Dispositivi | undefined>(undefined);
  const onDispClick = (disp: Dispositivi) => {
    setDisp(disp);
    setOpen(true);
  };
  const onNewClick = () => {
    setDisp(undefined);
    setOpen(true);
  };
  return (
    <>
      <Button onClick={onNewClick}>Aggiungi dispositivo</Button>
      <TabellaDispositivi risorsaId={risorseId} onClick={onDispClick} />
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true}>
        <Dispositivo
          dispositivo={disp}
          risorseId={risorseId}
          clubId={clubId}
          handleClose={() => setOpen(false)}
        />
      </Dialog>
    </>
  );
}

export function TabellaDispositivi(props: {
  risorsaId: number;
  onClick: (disp: Dispositivi) => void;
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { risorsaId, onClick } = props;
  const { isLoading, data } = useQuery<unknown, AxiosError, { dispositivi: Dispositivi[] }>(
    ["dispositivi/risorsa", risorsaId],
    () => axios.get(API_URL + "dispositivi/risorsa/" + risorsaId).then((res) => res.data)
  );

  const { mutate } = useMutation(
    (id: number) => {
      return axios.delete(API_URL + "dispositivi/" + id);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Dispositivo eliminato", { variant: "success" });
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const deleteDisp = (id: number) => mutate(id);

  if (isLoading) return <>Loading...</>;

  if (!data) return <></>;
  if (!("dispositivi" in data)) return <></>;
  if (data.dispositivi.length < 1) return <></>;

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell sx={{ width: "100%" }}>Nome</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.dispositivi.map((disp) => (
          <TableRow key={disp.id}>
            <TableCell>
              <IconButton sx={{ p: 0 }} onClick={() => onClick(disp)}>
                <EditIcon />
              </IconButton>
            </TableCell>
            <TableCell>
              <IconButton sx={{ p: 0 }} onClick={() => deleteDisp(disp.id)}>
                <DeleteIcon />
              </IconButton>
            </TableCell>
            <TableCell>{disp.descrizione}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
